import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@core/services/login.service';
import { UiService } from '@core/services/ui.service';
import { LanguageService } from '@i18n/services/language.service';
import { Store } from '@ngrx/store';
import { AppState } from '@redux/app.reducers';
import { StorageService } from '../../../core/services/core/storage.service';
import { MenuComponent, MENU_CONFIG_TOKEN } from '../menu/menu.component';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'mfp-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() border = false;
  @Input() logged = false;
  @Input() showMenu = false;

  tooltipActive = false;
  name = '';
  translation: any;

  active = '1';
  lifePlanId: string | null = '';
  protections = [
    {
      path: 'death',
      shortName: 'MENU.LIFE_PLAN.DEATH.SHORT_NAME',
      longName: 'MENU.LIFE_PLAN.DEATH.LONG_NAME',
      icon: 'assets/icons/bridge-dark.svg',
      productsAdded: 1,
      totalProducts: 1,
      healthPoints: 12,
    },
    {
      path: 'education',
      shortName: 'MENU.LIFE_PLAN.EDUCATION.SHORT_NAME',
      longName: 'MENU.LIFE_PLAN.EDUCATION.LONG_NAME',
      icon: 'assets/icons/flag-dark.svg',
      productsAdded: 1,
      totalProducts: 2,
      healthPoints: 8,
    },
    {
      path: 'savings',
      shortName: 'MENU.LIFE_PLAN.SAVINGS.SHORT_NAME',
      longName: 'MENU.LIFE_PLAN.SAVINGS.LONG_NAME',
      icon: 'assets/icons/two-people-wagon-dark.svg',
      productsAdded: 2,
      totalProducts: 2,
      healthPoints: 2,
    },
    {
      path: 'retirement',
      shortName: 'MENU.LIFE_PLAN.RETIREMENT.SHORT_NAME',
      longName: 'MENU.LIFE_PLAN.RETIREMENT.LONG_NAME',
      icon: 'assets/icons/palm-tree-dark.svg',
      productsAdded: 0,
      totalProducts: 2,
      healthPoints: 0,
    },
  ];
  clientEncryptedToken: string | null = '';

  constructor(
    private overlay: Overlay,
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private loginService: LoginService,
    private uiService: UiService,
    private language: LanguageService,
    private store: Store<AppState>,
    private authService: MsalService
  ) {
    this.route.params.subscribe({
      next: (params) => {
        this.lifePlanId = params.lifePlanId;
      },
    });
    this.language.stream('LAYOUT').subscribe({
      next: (translation) => (this.translation = translation),
    });
    if (this.router.url === '/agent/life-plans') {
      this.active = '0';
    }
    if (this.router.url === '/agent/commercial-guide') {
      this.active = '2';
    }
    this.store.subscribe({
      next: (state) => {
        this.name = state.agentData.agentName;
        this.clientEncryptedToken = state.clientData.clientEncryptedToken!;
      },
    });
  }

  ngOnInit() {
    if (this.storageService.get('access_token')) {
      this.logged = true;
    }
  }

  onMenuButtonClick(): void {
    const overlayRef = this.overlay.create({
      height: '100%',
      hasBackdrop: true,
      backdropClass: 'dark-backdrop',
      positionStrategy: this.overlay
        .position()
        .global()
        .right('0px')
        .top('0px'),
    });

    const injector = Injector.create({
      providers: [
        { provide: OverlayRef, useValue: overlayRef },
        {
          provide: MENU_CONFIG_TOKEN,
          useValue: {
            view: 'agent',
            lifePlanId: this.lifePlanId,
            opened: true,
            disabled: false,
            protections: this.protections,
          },
        },
      ],
    });

    const menuPortal = new ComponentPortal(MenuComponent, null, injector);

    overlayRef.backdropClick().subscribe({
      next: (_) => overlayRef.dispose(),
    });

    overlayRef.attach(menuPortal);
  }

  navigatePlanifications() {
    const idParam = this.clientEncryptedToken
      ? `?id=${this.clientEncryptedToken}`
      : '';
    this.router.navigateByUrl(`/agent/life-plans${idParam}`);
    return false;
  }

  navigateCommercialGuide() {
    this.router.navigateByUrl('/agent/commercial-guide');
    return false;
  }

  navigateSummary() {
    this.router.navigateByUrl(`/agent/life-plans/${this.lifePlanId}/summary`);
  }

  onLogout() {
    this.loginService.onLogout();
    this.authService.logoutRedirect();
    return false;
  }

  openTooltip() {
    this.tooltipActive = !this.tooltipActive;
  }
}
